import { render, staticRenderFns } from "./SystemConfiguration.vue?vue&type=template&id=11c88375&scoped=true"
import script from "./SystemConfiguration.vue?vue&type=script&lang=ts"
export * from "./SystemConfiguration.vue?vue&type=script&lang=ts"
import style0 from "./SystemConfiguration.vue?vue&type=style&index=0&id=11c88375&prod&scoped=true&lang=css"
import style1 from "./SystemConfiguration.vue?vue&type=style&index=1&id=11c88375&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c88375",
  null
  
)

export default component.exports